import React from 'react';
import Breadcrumb from './Breadcrumb';

export interface BreadcrumbElement {
  link?: string;
  text: string;
}

export interface BreadcrumbWithWrapperProps {
  id?: string;
  elements: BreadcrumbElement[];
  hideOnMobile?: boolean;
  className?: string;
}

function BreadcrumbWithWrapper({
  id = '',
  elements,
  hideOnMobile = false,
  className = '',
}: Readonly<BreadcrumbWithWrapperProps>) {
  return (
    <div
      id={id}
      className={`${hideOnMobile ? 'hidden' : 'block'} breadcrumb-with-wrapper ${className}`}
    >
      <Breadcrumb elements={elements} />
    </div>
  );
}

export default BreadcrumbWithWrapper;
